import styled from 'styled-components'
const SupplierPurchaseListWrapper = styled.div`
  .btn-center {
    text-align: center
  }

  .text-right {
    text-align: right
  }

  .header {
    margin: 5px;
  }

  .link-form {
    color: ${(props) => props.theme.tokens.accent};
    cursor:pointer;
  }

  .image-container {
    display: inline;
    flex-wrap: wrap;
  }

  .chat-button {
    background: ${(props) => props.theme.tokens.success};

    i {
      color: ${(props) => props.theme.tokens.textOnAccent};
    }
  }

  .icon-button {
    width: 40px;
    margin-right: 8px;
  }

  .image-container > img {
    border: 1px solid ${(props) => props.theme.tokens.border};
    border-radius: 1px;
    padding: 1px;
    margin: 1px;
    width: 30px;
  }

  .detail-container > span {
    color: ${(props) => props.theme.tokens.textPrimary};
  }

  .btn-margin > button {
    margin-left: 10px;
  }

  .table-row-light {
    background-color: ${(props) => props.theme.tokens.surfaceMuted};
    color: gray;
  }
`
export default SupplierPurchaseListWrapper